import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Globe, Edit2 } from "lucide-react";
import { initialPages } from "../../lib/mockData";

export function PageView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const page = initialPages.find((p) => p.id === Number(id));
  if (!page)
    return (
      <div className="max-w-[900px] mx-auto">
        <p className="text-muted-foreground">Page not found.</p>
      </div>
    );

  return (
    <div className="max-w-[900px] mx-auto space-y-5">
      <div className="page-header">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/pages")}
            className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-muted text-muted-foreground transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <div>
            <h1 className="page-title">{page.title}</h1>
            <p className="page-subtitle flex items-center gap-1">
              <Globe className="w-3.5 h-3.5" />
              {page.slug}
            </p>
          </div>
        </div>
        <button
          className="btn-accent"
          onClick={() => navigate(`/pages/${page.id}/edit`)}
        >
          <Edit2 className="w-4 h-4" /> Edit Page
        </button>
      </div>
      <div className="section-panel">
        <div className="section-panel-header">
          <h2 className="section-panel-title">Page Details</h2>
          <span className={`status-${page.status}`}>
            <span className="w-1.5 h-1.5 rounded-full bg-current" />
            {page.status}
          </span>
        </div>
        <div className="section-panel-body space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">
                Template
              </p>
              <p className="text-sm text-foreground mt-1">{page.template}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">
                Author
              </p>
              <p className="text-sm text-foreground mt-1">{page.author}</p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">
                Last Modified
              </p>
              <p className="text-sm text-foreground mt-1">
                {page.lastModified}
              </p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">
                Slug
              </p>
              <p className="text-sm font-mono text-foreground mt-1">
                {page.slug}
              </p>
            </div>
          </div>
          {page.heroHeading && (
            <>
              <div className="pt-3 border-t border-border">
                <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">
                  Hero Heading
                </p>
                <p className="text-sm text-foreground mt-1">
                  {page.heroHeading}
                </p>
              </div>
            </>
          )}
          {page.seoTitle && (
            <div className="pt-3 border-t border-border">
              <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">
                SEO Title
              </p>
              <p className="text-sm text-foreground mt-1">{page.seoTitle}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
